// The header the Script and Timeline views share, under the top bar: the small live preview on the left (tap to play or
// pause, a chip with the time, a full screen button) and on the right the Quick | Script | Timeline tabs with the add
// tiles. ViewTabs is the tab selector on its own, so Quick view can use it too.
import type { ReactNode } from "react";
import { pictureAt, type TimelineEpisode } from "../../model/timeline";
import { Icon } from "../common";
import { NEEDS_LINE, type View } from "./EditorShell";
import { Stage, fmtT } from "./Stage";
import "./episodeHead.css";

export function EpisodeHead({ ep, t, playing, playable, onToggle, onFull, onAddPicture, view, onView, children, tiles }: {
  ep: TimelineEpisode; t: number; playing: boolean; playable: boolean; onToggle: () => void; onFull: () => void; onAddPicture: () => void;
  view: View; onView: (v: View) => void; children?: ReactNode; tiles: "script" | "timeline";
}) {
  const empty = !pictureAt(ep, t);
  const hint = ep.pictures.length && !ep.lines.length ? NEEDS_LINE : undefined;
  return (
    <div className="eh">
      <div className="eh-preview">
        <Stage ep={ep} t={t} onAddPicture={onAddPicture} />
        {!empty && (
          <>
            <button className="eh-hit" disabled={!playable} title={playable ? undefined : hint} aria-label={playing ? "Pause" : `Play from ${fmtT(t)}`} onClick={onToggle} />
            <span className="eh-chip" aria-hidden="true"><Icon name={playing ? "pause" : "play"} size={11} />{fmtT(t)}</span>
            {playable && <button className="eh-full" onClick={onFull} aria-label="Play full screen" title="Play full screen"><Icon name="expand" size={15} /></button>}
          </>
        )}
      </div>
      <div className="eh-side">
        <ViewTabs view={view} onView={onView} />
        <div className={`eh-tiles ${tiles}`}>{children}</div>
      </div>
    </div>
  );
}

// Quick | Script | Timeline. The caller keeps the choice (TimelineEditor remembers it per episode).
export function ViewTabs({ view, onView }: { view: View; onView: (v: View) => void }) {
  return (
    <div className="eh-tabs" role="tablist" aria-label="View">
      {VIEWS.map(([v, label]) => <button key={v} role="tab" aria-selected={view === v} onClick={() => { if (v !== view) onView(v); }}>{label}</button>)}
    </div>
  );
}
const VIEWS: [View, string][] = [["quick", "Quick"], ["script", "Script"], ["timeline", "Timeline"]];

export function Tile({ icon, label, sub, onClick, disabled, small }: { icon: string; label: string; sub?: string; onClick: () => void; disabled?: boolean; small?: boolean }) {
  return (
    <button className={`eh-tile${small ? " small" : ""}`} disabled={disabled} onClick={onClick}>
      <span className="eh-ico"><Icon name={icon} size={small ? 18 : 24} /></span>
      <span className="eh-lbl"><b>{label}</b>{sub && <span>{sub}</span>}</span>
    </button>
  );
}
